import { useSelector } from "react-redux";
import { CallerInfo } from "./CallerInfo";
import CallerHeader from "./calllogsHeader";
import { ExistingQuery } from "./ExistingQuery";
import { selectCustomerInfo } from "src/stores/calllogs";

export const OutGoingCall = ({
  callerInfo,
  //  onClose
}) => {
  const customerInfo = useSelector(selectCustomerInfo);
  const result = customerInfo?.data?.result;
  return (
    <>
      <CallerHeader callerInfo={callerInfo} />
      <CallerInfo callerInfo={callerInfo} />
      {result && <ExistingQuery />}
    </>
  );
};
